export function sortAlphabetically(a, b, desc) {
    if(desc) {
        return a > b ? 1 : -1
    } 
    return a < b ? 1 : -1
}


// WEBPACK FOOTER //
// ./src/utils/OrderUtils.js